import { UntypedFormControl } from '@angular/forms';

export type ModulePropertyConstructor = { new (): ModulePropertySpecification };

export type ModulePropertySpecification =
    | IntegerSpecificationModel
    | StringSpecificationModel
    | NumberSpecificationModel
    | RangeSpecificationModel
    | FileSpecificationModel
    | FileListSpecificationModel
    | BinaryChoiceSpecificationModel
    | SingleChoiceSpecificationModel
    | string;

export class IntegerSpecificationModel {
    min?: number;
    max?: number;
}

export class StringSpecificationModel {
    length?: IntegerSpecificationModel;
}

export class NumberSpecificationModel {
    lower_inclusive?: number;
    upper_inclusive?: number;
    lower_exclusive?: number;
    upper_exclusive?: number;
}
/* eslint-enable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class RangeSpecificationModel {
    lower?: NumberSpecificationModel = new NumberSpecificationModel();
    upper?: NumberSpecificationModel = new NumberSpecificationModel();
}

export class FileSpecificationModel {
    format?: string | string[];
}

export class FileListSpecificationModel {
    count?: IntegerSpecificationModel;
    format?: string | string[];
}

type BinaryChoiceSpecificationModel = boolean;

export type SingleChoiceSpecificationModel = string[];

/***  Widget Definition ***/
export type ModuleWidgetConstructor = { new (): ModuleWidget };

export type ModuleWidget = SliderWidget | RangeSliderWidget | TextBoxWidget | CheckboxWidget | RadioButtonGroupWidget | DropdownWidget | FileDialogWidget;

export class TextBoxWidget {}

export class SliderWidget {
    step?: number;
}

export class RangeSliderWidget {
    step?: number;
}

export class CheckboxWidget {}

export class RadioButtonGroupWidget {
    items: StringResource[] = [];
}

export class DropdownWidget {
    items: StringResource[] = [];
}

export class FileDialogWidget {}

/*** Others ***/
export class StringResource {
    key: string;
    label: string;

    /* undefined at backend */
    control?: UntypedFormControl;
}
